import React from 'react';
import './testimonial.css'; // CSS file import

const testimonials = [
  {
    id: 1,
    name: 'Surender Sharma',
    role: 'Marketing Head',
    image: "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?auto=format&fit=crop&w=600&q=80",
    message: 'This service helped me grow my business rapidly!',
  },
  {
    id: 2,
    name: 'Rajat Mehta',
    role: 'CEO',
    image: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?auto=format&fit=crop&w=600&q=60",
    message: 'Amazing experience! Highly recommend to everyone.',
  },
  {
    id: 3,
    name: 'Anjali Singh',
    role: 'Product Manager',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=600&q=80',
    message: 'Very professional team and great support!',
  },
  {
    id: 4,
    name: "Aman Gupta",
    role: "Tech Lead",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=600&q=60",
    linkedin: "#",
    message: "The team delivered exceptional results on time. Highly recommend Aman’s guidance!"
  },
];

const Testimonial = () => {
  return (
    <div className="testimonial-container">
      <h2>What Our Clients Say</h2>
      <div className="testimonial-slider">
        {testimonials.map((t) => (
          <div key={t.id} className="testimonial-card">
            <img src={t.image} alt={t.name} />
            <h3>{t.name}</h3>
            <p className="role">{t.role}</p>
            <p className="message">"{t.message}"</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
